<section class="hero-section relative w-full min-h-[50vh] overflow-hidden bg-black flex items-center">
    <div class="absolute inset-0 z-0">
        <video
            class="w-full h-full object-cover object-center opacity-100"
            src="/videos/istock.mp4"
            poster="/images/hero-section.jpg"
            autoplay
            muted
            loop
            playsinline>
        </video>
    </div>

    <div class="relative z-10 w-full max-w-screen-2xl mx-auto py-12 sm:py-14 md:py-16 lg:py-18 px-4 sm:px-6 lg:px-8">
        <div class="max-w-[90%] sm:max-w-sm md:max-w-lg lg:max-w-xl xl:max-w-2xl">
            <h1 class="hero-headline text-white font-medium leading-tight tracking-tight mb-5 sm:mb-6 md:mb-7
                 text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-6xl">
                A safer space to explore connection, conversation &amp; kink.
            </h1>

            <p class="hero-subtext text-white/85 font-normal leading-relaxed mb-7 sm:mb-10 md:mb-12
                text-sm sm:text-base md:text-base lg:text-lg max-w-full sm:max-w-sm md:max-w-md lg:max-w-xl">
                Join a private, consent-focused community where you can express yourself openly, build meaningful
                connections, and share without fear of censorship.
            </p>

            <div class="flex flex-wrap gap-3 sm:gap-4">
                <button class="hero-btn-outline
                 px-5 sm:px-8 py-3 sm:py-4
                 bg-white text-[#e0144c] border-2 border-white
                 text-sm sm:text-base font-semibold tracking-wide
                 rounded-md
                 transition-all duration-200 ease-in-out
                 hover:bg-transparent hover:text-white
                 focus:outline-none focus:ring-2 focus:ring-white/50
                 cursor-pointer whitespace-nowrap
                 text-center" type="button" routerLink="/all">
                    Explore Community
                </button>

                <!-- <button class="hero-btn-primary
                 px-5 sm:px-8 py-3 sm:py-4
                 bg-[#e0144c] text-white border-2 border-[#e0144c]
                 text-sm sm:text-base font-semibold tracking-wide
                 rounded-md
                 transition-all duration-200 ease-in-out
                 hover:bg-[#c0103f] hover:border-[#c0103f]
                 focus:outline-none focus:ring-2 focus:ring-[#e0144c]/50
                 cursor-pointer whitespace-nowrap
                 text-center" type="button">
                    Browse products
                </button> -->
            </div>
        </div>
    </div>
</section>

<!-- Content sections: visibility, order and headings are managed by the super
     admin in Admin → Home Page Content. The content inside each section
     (hand-picked and/or trending) comes from the /featured endpoints. -->
<ng-container *ngFor="let section of homeSections; trackBy: trackBySectionKey">
    <ng-container [ngSwitch]="section.key">

        <section *ngSwitchCase="'POSTS'" class="relative w-full overflow-hidden py-10 sm:py-14 md:py-16">
            <div class="relative z-10 w-full max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex items-start justify-between gap-4 mb-6 sm:mb-8">
                    <div>
                        <h2 class="text-black font-bold text-base sm:text-xl md:text-3xl tracking-tight leading-snug">
                            {{ section.title }}
                        </h2>
                        <p *ngIf="section.subtitle" class="mt-1 text-gray-600 text-sm sm:text-base">{{ section.subtitle }}</p>
                    </div>
                    <a routerLink="/posts"
                        class="flex items-center gap-1.5 text-black text-sm sm:text-base font-medium hover:text-[#e0144c] transition-colors duration-200 whitespace-nowrap">
                        View all
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                    </a>
                </div>

                <app-posts [featured]="true" [embedded]="true" [uniform]="true"></app-posts>
            </div>
        </section>

        <section *ngSwitchCase="'EVENTS'" class="relative w-full overflow-hidden py-10 sm:py-14 md:py-16">
            <div class="absolute inset-0 z-0">
                <img src="/images/post-section-bg.png" alt="" class="w-full h-full object-cover object-center" />
                <div class="absolute inset-0 bg-black/55"></div>
            </div>
            <div class="relative z-10 w-full max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex items-start justify-between gap-4 mb-6 sm:mb-8">
                    <div>
                        <h2 class="text-white font-bold text-base sm:text-xl md:text-3xl tracking-tight leading-snug">
                            {{ section.title }}
                        </h2>
                        <p *ngIf="section.subtitle" class="mt-1 text-white/80 text-sm sm:text-base">{{ section.subtitle }}</p>
                    </div>
                    <a routerLink="/events"
                        class="flex items-center gap-1.5 text-white text-sm sm:text-base font-medium hover:text-[#e0144c] transition-colors duration-200 whitespace-nowrap">
                        View all
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                    </a>
                </div>

                <app-events [featured]="true" [embedded]="true" [uniform]="true"></app-events>
            </div>
        </section>

        <section *ngSwitchCase="'BLOGS'" class="relative w-full overflow-hidden py-10 sm:py-14 md:py-16">
            <div class="absolute inset-0 z-0">
                <img src="/images/blog-bg.png" alt="" class="w-full h-full object-cover object-center" />
            </div>
            <div class="relative z-10 w-full max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex items-start justify-between gap-4 mb-6 sm:mb-8">
                    <div>
                        <h2 class="text-white font-bold text-base sm:text-xl md:text-3xl tracking-tight leading-snug">
                            {{ section.title }}
                        </h2>
                        <p *ngIf="section.subtitle" class="mt-1 text-white/80 text-sm sm:text-base">{{ section.subtitle }}</p>
                    </div>
                    <a routerLink="/blogs"
                        class="flex items-center gap-1.5 text-white text-sm sm:text-base font-medium hover:text-[#e0144c] transition-colors duration-200 whitespace-nowrap">
                        View all
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                    </a>
                </div>

                <app-blog [featured]="true" [embedded]="true" [uniform]="true"></app-blog>
            </div>
        </section>

    </ng-container>
</ng-container>

<!-- <section class="relative w-full overflow-hidden py-10 sm:py-14 md:py-16">

    <div class="absolute inset-0 z-0">
        <img src="/images/product-home-back.svg" alt="" class="w-full h-full object-cover object-center" />
    </div>

    <div class="relative z-10 w-full max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">

        <div class="flex items-start justify-between mb-6 sm:mb-8">
            <h2 class="text-black font-bold text-base sm:text-xl md:text-3xl tracking-tight leading-snug">Recommended for you</h2>
            <a href="#"
                class="flex items-center gap-1.5 text-black text-sm sm:text-base font-medium hover:text-[#e0144c] transition-colors whitespace-nowrap">
                View full shop
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
            </a>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">

            <div *ngFor="let product of products; trackBy: trackById; let i = index"
                class="bg-white rounded-2xl overflow-hidden flex flex-col shadow-md transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
                [style.animation-delay]="(i * 0.08 + 0.05) + 's'" [style.animation]="'fadeUp 0.6s ease-out both'">

                <div class="relative w-full bg-white overflow-hidden" style="aspect-ratio: 1/1;">

                    <div class="absolute top-5 left-5 z-10">
                        <span class="text-xs font-semibold px-3 py-1 rounded-full border bg-white"
                            [ngClass]="badgeClass(product.badge)">
                            {{ product.badge }}
                        </span>
                    </div>

                    <img *ngFor="let img of product.images; let di = index; trackBy: trackByIndex" [src]="img"
                        [alt]="product.title"
                        class="absolute inset-0 w-full h-full object-contain p-4 transition-opacity duration-500"
                        [class.opacity-100]="di === (product.activeSlide ?? 0)"
                        [class.opacity-0]="di !== (product.activeSlide ?? 0)" />
                </div>

                <div *ngIf="product.images.length > 1" class="flex items-center justify-center gap-1.5 pt-2 pb-0">
                    <button *ngFor="let img of product.images; let di = index; trackBy: trackByIndex"
                        (click)="goToSlide(product, di)"
                        class="rounded-full transition-all duration-300 focus:outline-none" [style.height]="'6px'"
                        [style.width]="di === (product.activeSlide ?? 0) ? '16px' : '6px'"
                        [style.background-color]="di === (product.activeSlide ?? 0) ? '#e0144c' : '#d1d5db'"></button>
                </div>

                <div class="px-4 pt-3 pb-4 flex flex-col gap-2 flex-1">

                    <div class="flex items-center justify-between">
                        <div class="flex items-center gap-4 text-gray-500 text-sm">
                            <button class="flex items-center gap-1.5 hover:text-[#e0144c] transition-colors">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g opacity="0.7">
                                        <path
                                            d="M7.48047 18.35L10.5805 20.75C10.9805 21.15 11.8805 21.35 12.4805 21.35H16.2805C17.4805 21.35 18.7805 20.45 19.0805 19.25L21.4805 11.95C21.9805 10.55 21.0805 9.35003 19.5805 9.35003H15.5805C14.9805 9.35003 14.4805 8.85003 14.5805 8.15003L15.0805 4.95003C15.2805 4.05003 14.6805 3.05003 13.7805 2.75003C12.9805 2.45003 11.9805 2.85003 11.5805 3.45003L7.48047 9.55003"
                                            stroke="#858585" stroke-width="1.5" stroke-miterlimit="10" />
                                        <path
                                            d="M2.37988 18.35V8.55002C2.37988 7.15002 2.97988 6.65002 4.37988 6.65002H5.37988C6.77988 6.65002 7.37988 7.15002 7.37988 8.55002V18.35C7.37988 19.75 6.77988 20.25 5.37988 20.25H4.37988C2.97988 20.25 2.37988 19.75 2.37988 18.35Z"
                                            stroke="#858585" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </g>
                                </svg>
                                <span>{{ product.likes }}</span>
                            </button>

                            <button class="flex items-center gap-1.5 hover:text-[#e0144c] transition-colors">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g opacity="0.7">
                                        <path
                                            d="M21 12C21 16.9706 16.9706 21 12 21C10.8029 21 9.6603 20.7663 8.61549 20.3419C8.41552 20.2607 8.31554 20.2201 8.23472 20.202C8.15566 20.1843 8.09715 20.1778 8.01613 20.1778C7.9333 20.1778 7.84309 20.1928 7.66265 20.2229L4.10476 20.8159C3.73218 20.878 3.54589 20.909 3.41118 20.8512C3.29328 20.8007 3.19933 20.7067 3.14876 20.5888C3.09098 20.4541 3.12203 20.2678 3.18413 19.8952L3.77711 16.3374C3.80718 16.1569 3.82222 16.0667 3.82221 15.9839C3.8222 15.9028 3.81572 15.8443 3.798 15.7653C3.77988 15.6845 3.73927 15.5845 3.65806 15.3845C3.23374 14.3397 3 13.1971 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                                            stroke="#858585" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </g>
                                </svg>
                                <span>{{ product.comments }}</span>
                            </button>

                            <button class="flex items-center gap-1.5 hover:text-[#e0144c] transition-colors">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g opacity="0.7">
                                        <path
                                            d="M20.7914 12.6074C21.0355 12.3981 21.1575 12.2935 21.2023 12.169C21.2415 12.0598 21.2415 11.9402 21.2023 11.831C21.1575 11.7065 21.0355 11.6018 20.7914 11.3926L12.3206 4.13196C11.9004 3.77176 11.6903 3.59166 11.5124 3.58725C11.3578 3.58342 11.2101 3.65134 11.1124 3.77122C11 3.90915 11 4.18589 11 4.73936V9.03462C8.86532 9.40807 6.91159 10.4897 5.45971 12.1139C3.87682 13.8845 3.00123 16.1759 3 18.551V19.1629C4.04934 17.8989 5.35951 16.8765 6.84076 16.1659C8.1467 15.5394 9.55842 15.1683 11 15.0705V19.2606C11 19.8141 11 20.0908 11.1124 20.2288C11.2101 20.3486 11.3578 20.4166 11.5124 20.4127C11.6903 20.4083 11.9004 20.2282 12.3206 19.868L20.7914 12.6074Z"
                                            stroke="#858585" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </g>
                                </svg>
                                <span>{{ product.shares }}</span>
                            </button>
                        </div>

                        <button class="w-10 h-10 rounded-full flex items-center justify-center shadow-md flex-shrink-0
                        bg-[radial-gradient(circle,_#DA3D6A_80%,_#D35266_100%)]
                        hover:bg-[radial-gradient(circle,_#c7365e_80%,_#b84456_100%)]
                        transition-colors">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M6.99121 15.4084V6.94169C6.99121 6.60835 7.09121 6.28335 7.27454 6.00835L9.54954 2.62502C9.90788 2.08335 10.7995 1.70002 11.5579 1.98335C12.3745 2.25835 12.9162 3.17502 12.7412 3.99169L12.3079 6.71669C12.2745 6.96669 12.3412 7.19169 12.4829 7.36669C12.6245 7.52502 12.8329 7.62502 13.0579 7.62502H16.4829C17.1412 7.62502 17.7079 7.89169 18.0412 8.35835C18.3579 8.80835 18.4162 9.39169 18.2079 9.98335L16.1579 16.225C15.8995 17.2584 14.7745 18.1 13.6579 18.1H10.4079C9.84954 18.1 9.06621 17.9084 8.70788 17.55L7.64121 16.725C7.23288 16.4167 6.99121 15.925 6.99121 15.4084Z"
                                    fill="white" />
                                <path
                                    d="M4.34199 5.31665H3.48366C2.19199 5.31665 1.66699 5.81665 1.66699 7.04998V15.4333C1.66699 16.6666 2.19199 17.1666 3.48366 17.1666H4.34199C5.63366 17.1666 6.15866 16.6666 6.15866 15.4333V7.04998C6.15866 5.81665 5.63366 5.31665 4.34199 5.31665Z"
                                    fill="white" />
                            </svg>
                        </button>
                    </div>
                    <div class="flex items-center justify-between">
                        <div class="flex items-baseline gap-1">
                            <span class="text-gray-400 text-sm line-through">£ {{ product.originalPrice }}</span>
                            <span class="text-gray-900 font-bold text-xl">£ {{ product.salePrice }}</span>
                        </div>
                    </div>

                    <p class="text-gray-900 font-semibold text-md leading-tight">{{ product.title }}</p>

                    <p class="text-[#D31148] text-sm font-medium">{{ product.merchant }}</p>

                    <div class="flex items-center gap-1.5">
                        <svg *ngFor="let s of stars(product.rating)" xmlns="http://www.w3.org/2000/svg"
                            class="w-4 h-4 text-yellow-400" viewBox="0 0 24 24" fill="currentColor">
                            <path fill-rule="evenodd"
                                d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005z"
                                clip-rule="evenodd" />
                        </svg>
                        <span class="text-gray-600 text-sm font-medium">{{ product.rating }} star</span>
                        <span class="text-[#D31148] text-sm font-medium">({{ product.reviewCount }} reviews)</span>
                    </div>

                    <button
                        class="mt-auto w-full bg-[#D31148] active:scale-95 text-white font-semibold text-md py-3 rounded-xl transition-all duration-200 flex items-center justify-center gap-2">
                        Add to cart
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M2.3335 2.33398H3.85735C4.14438 2.33398 4.28789 2.33398 4.40338 2.38676C4.50515 2.43328 4.5914 2.50808 4.65184 2.60225C4.72042 2.70912 4.74072 2.85119 4.78131 3.13532L5.3335 7.00065M5.3335 7.00065L6.5607 16.0206C6.71644 17.1653 6.7943 17.7376 7.06795 18.1684C7.30907 18.548 7.65476 18.8498 8.06341 19.0376C8.52717 19.2507 9.10476 19.2507 10.26 19.2507H20.2442C21.3438 19.2507 21.8936 19.2507 22.3429 19.0528C22.7391 18.8784 23.079 18.5971 23.3245 18.2406C23.6029 17.8362 23.7058 17.2961 23.9115 16.2159L25.4558 8.10862C25.5282 7.72843 25.5644 7.53833 25.5119 7.38973C25.4659 7.25938 25.3751 7.14962 25.2556 7.08001C25.1195 7.00065 24.926 7.00065 24.5389 7.00065H5.3335ZM11.6668 24.5007C11.6668 25.145 11.1445 25.6673 10.5002 25.6673C9.85583 25.6673 9.3335 25.145 9.3335 24.5007C9.3335 23.8563 9.85583 23.334 10.5002 23.334C11.1445 23.334 11.6668 23.8563 11.6668 24.5007ZM21.0002 24.5007C21.0002 25.145 20.4778 25.6673 19.8335 25.6673C19.1892 25.6673 18.6668 25.145 18.6668 24.5007C18.6668 23.8563 19.1892 23.334 19.8335 23.334C20.4778 23.334 21.0002 23.8563 21.0002 24.5007Z"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>

                </div>
            </div>

        </div>
    </div>
</section> -->

<section class="bg-[#f2f2f0] flex items-center justify-center px-4 py-14">
  <div class="w-full max-w-2xl">

    <!-- Header -->
    <div class="text-center mb-12 sm:mb-14">
      <h1 class="text-3xl sm:text-4xl md:text-[2.6rem] font-semibold text-[#1a1a24] tracking-tight leading-tight mb-3">
        Frequently asked questions
      </h1>
      <p class="text-sm sm:text-base text-[#6b6b6b] font-light">
        Everything you need to know about Safeword
      </p>
    </div>

    <!-- FAQ List -->
    <div class="flex flex-col gap-3">
      <div
        *ngFor="let faq of faqs"
        class="bg-white rounded-2xl border transition-all duration-300"
        [class.border-[#d0d0cc]]="faq.isOpen"
        [class.shadow-md]="faq.isOpen"
        [class.border-[#e0e0dd]]="!faq.isOpen"
        [class.hover:border-[#d0d0cc]]="!faq.isOpen"
        [class.hover:shadow-sm]="!faq.isOpen">

        <!-- Question Button -->
        <button
          (click)="toggle(faq)"
          [attr.aria-expanded]="faq.isOpen"
          class="w-full flex items-center gap-4 px-5 sm:px-6 py-5 sm:py-[22px] text-left cursor-pointer group">

          <!-- Plus / X Icon -->
          <span
            class="flex-shrink-0 w-7 h-7 rounded-full border-[1.5px] flex items-center justify-center transition-all duration-300 relative"
            [class.border-[#8a8a8a]]="!faq.isOpen"
            [class.group-hover:border-[#1a1a24]]="!faq.isOpen"
            [class.bg-[#1a1a24]]="faq.isOpen"
            [class.border-[#1a1a24]]="faq.isOpen"
            [class.rotate-45]="faq.isOpen"
            aria-hidden="true">
            <!-- Horizontal bar -->
            <span
              class="absolute w-[10px] h-[1.5px] rounded-sm transition-colors duration-300"
              [class.bg-[#8a8a8a]]="!faq.isOpen"
              [class.group-hover:bg-[#1a1a24]]="!faq.isOpen"
              [class.bg-white]="faq.isOpen">
            </span>
            <!-- Vertical bar -->
            <span
              class="absolute w-[1.5px] h-[10px] rounded-sm transition-colors duration-300"
              [class.bg-[#8a8a8a]]="!faq.isOpen"
              [class.group-hover:bg-[#1a1a24]]="!faq.isOpen"
              [class.bg-white]="faq.isOpen">
            </span>
          </span>

          <!-- Question Text -->
          <span
            class="flex-1 text-sm sm:text-base font-normal leading-relaxed transition-colors duration-200"
            [class.text-[#1a1a24]]="faq.isOpen"
            [class.text-[#2a2a2a]]="!faq.isOpen">
            {{ faq.question }}
          </span>
        </button>

        <!-- Answer (animated expand) -->
        <div
          class="overflow-hidden transition-all duration-300 ease-in-out"
          [style.max-height]="faq.isOpen ? '300px' : '0px'"
          [style.opacity]="faq.isOpen ? '1' : '0'">
          <p class="px-5 sm:px-6 pb-5 sm:pb-[22px] pl-[68px] sm:pl-[72px] text-sm sm:text-[0.9375rem] text-[#555555] font-light leading-7">
            {{ faq.answer }}
          </p>
        </div>

      </div>
    </div>

  </div>
</section>